module.exports = __webpack_public_path__ + "img/icon_2.2a3c7e4d.png";